<button
  #trigger
  type="button"
  class="bks__trigger"
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  role="combobox"
  aria-haspopup="listbox"
  [attr.id]="inputId"
  [attr.aria-describedby]="describedBy"
  [attr.aria-expanded]="open"
  [attr.aria-controls]="open ? listId : null"
  [disabled]="disabled"
  [class.is-open]="open"
  (click)="toggle()"
  (keydown)="onTriggerKeydown($event)"
>
  @if (selected; as option) {
    @if (variant === "sender") {
      <span class="bks__tile" aria-hidden="true">{{ initials(option.label) }}</span>
    }
    <span class="bks__value">{{ option.label }}</span>
    @if (option.hint) {
      <span class="bks__hint">{{ option.hint }}</span>
    }
  } @else {
    <span class="bks__placeholder">
      {{ loading ? "Loading " + plural + "…" : all.length ? placeholder : emptyText }}
    </span>
  }
  <span class="bk-sym bks__chevron" aria-hidden="true">expand_more</span>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="open"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayWidth]="panelWidth"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayPush]="true"
  (attach)="onAttached()"
  (detach)="close(false)"
  (overlayOutsideClick)="onOutsideClick($event)"
  (positionChange)="onPositionChange($event)"
>
  <div class="bks__panel" [id]="panelId" [class.is-above]="above" (keydown)="onPanelKeydown($event)">
    @if (searchable) {
      <div class="bks__search">
        <span class="bk-sym bks__search-icon" aria-hidden="true">search</span>
        <input
          #search
          type="text"
          class="bks__search-input"
          [value]="query"
          [placeholder]="'Search ' + plural"
          [attr.aria-label]="'Search ' + plural"
          [attr.aria-controls]="listId"
          [attr.aria-activedescendant]="activeId"
          autocomplete="off"
          spellcheck="false"
          (input)="onSearch($any($event.target).value)"
        />
        @if (query) {
          <span class="bks__count" aria-live="polite">{{ shown.length }} of {{ all.length }}</span>
        }
      </div>
    }

    <ul
      #list
      class="bks__list"
      [class.has-query]="!!query"
      role="listbox"
      [id]="listId"
      [attr.tabindex]="searchable ? null : 0"
      [attr.aria-activedescendant]="searchable ? null : activeId"
      [attr.aria-label]="plural"
    >
      @for (option of shown; track option.value; let i = $index) {
        <li
          class="bks__option"
          role="option"
          [id]="optionId(i)"
          [attr.aria-selected]="option.value === value"
          [class.is-active]="i === active"
          [class.is-selected]="option.value === value"
          (mousedown)="$event.preventDefault()"
          (mousemove)="active = i"
          (click)="choose(option)"
        >
          @if (variant === "sender") {
            <span class="bks__tile" aria-hidden="true">{{ initials(option.label) }}</span>
          }
          <span class="bks__text">
            <span class="bks__label">{{ option.pre }}<b class="bks__hit">{{ option.hit }}</b>{{ option.post }}</span>
            @if (option.detail) {
              <span class="bks__detail">{{ option.detail }}</span>
            }
          </span>
          @if (option.hint) {
            <span class="bks__hint">{{ option.hint }}</span>
          }
          <span class="bk-sym bks__check" aria-hidden="true">check</span>
        </li>
      } @empty {
        <li class="bks__empty" role="presentation">
          @if (query) {
            No {{ noun }} matches “{{ query }}”.
          } @else if (loading) {
            Loading {{ plural }}…
          } @else {
            {{ emptyText }}
          }
        </li>
      }
    </ul>
  </div>
</ng-template>
